import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo, useState } from 'react'
import styled from 'styled-components'

import { startMfaSetupEvent } from '@root/features/auth/setup-otp/atoms'
import {
  settingScreenAction,
  settingScreenAtom,
} from '@root/features/settings/settings-screen/atoms'
import { useWarmPolicyIframes } from '@root/features/settings/settings-screen/hooks/use-warm-policy-iframes'
import { SETTINGS_HEADER_MAP } from '@root/features/settings/settings-screen/model'
import { SettingsView } from '@root/features/settings/settings-screen/ui/settings-view'
import { environmentAtom } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import { SettingsDrawerReturn } from './settings-drawer-return'

import type { SetupOtpMode } from '@root/features/auth/setup-otp/ui'

export const SettingsDrawer: React.FC = () => {
  const [env] = useAtom(environmentAtom)
  const { t } = useTranslation()
  const [optMode, setOptMode] = useState<SetupOtpMode>('instructions')
  const [screen, setSettingScreen] = useAtom(settingScreenAtom)
  const settingScreen = useAction(settingScreenAction)

  const open = screen !== undefined

  useWarmPolicyIframes(env.policiesHost, open)

  const [headerTitle, returnHandler] = useMemo(
    () =>
      SETTINGS_HEADER_MAP({
        screen,
        optMode,
        setOptMode,
        setScreen: (screen) => settingScreen(screen),
      }),
    [screen, optMode, setOptMode, settingScreen],
  )

  startMfaSetupEvent.onCall(() => settingScreen('setup-otp'))

  return (
    <Root
      title={t(headerTitle)}
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          setSettingScreen(undefined)
        }
      }}
    >
      <Body>
        <SettingsDrawerReturn onReturn={returnHandler} />
        <SettingsView
          screen={screen}
          optMode={optMode}
          setOptMode={setOptMode}
          setScreen={(screen) => settingScreen(screen)}
        />
      </Body>
    </Root>
  )
}

const Root = styled(Drawer)`
  top: var(--safe-top);
  bottom: 0;
  height: auto;
  max-height: none;
`

const Body = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;
`
